import { Reveal, SectionLabel } from "./Reveal";
import { Icon } from "@/lib/icons";
import { ArrowRight } from "lucide-react";

export default function Courses({ site, courses }) {
  const s = site?.coursesSection || {};
  const go = () => document.querySelector("#admission")?.scrollIntoView({ behavior: "smooth" });
  return (
    <section id="courses" className="py-24 lg:py-32 bg-[var(--c-bg)] paper-texture">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <Reveal className="text-center max-w-3xl mx-auto">
          <SectionLabel>{s.label}</SectionLabel>
          <h2 className="font-heading font-bold text-[var(--c-primary)] mt-5 text-3xl sm:text-4xl lg:text-5xl">{s.title}</h2>
          <p className="font-body text-[var(--c-muted)] mt-5 text-base sm:text-lg">{s.subtitle}</p>
        </Reveal>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6 mt-14">
          {(courses || []).map((c, i) => (
            <Reveal key={c.id || i} delay={(i % 4) * 0.07}>
              <div
                data-testid={`course-card-${i}`}
                className="group h-full flex flex-col bg-[var(--c-card)] rounded-2xl border border-[var(--c-border)] overflow-hidden hover:shadow-[0_25px_60px_-30px_rgba(106,27,26,0.45)] transition-[box-shadow,transform] duration-300 hover:-translate-y-1"
              >
                <div className="relative h-40 overflow-hidden">
                  <img src={c.image} alt={c.title} loading="lazy" className="w-full h-full object-cover group-hover:scale-105 duration-700 ease-out" />
                  <div className="absolute inset-0 bg-gradient-to-t from-[var(--c-primary)]/60 to-transparent" />
                  <span className="absolute top-3 left-3 grid place-items-center h-10 w-10 rounded-full bg-[var(--c-bg)]/90 text-[var(--c-primary)]">
                    <Icon name={c.icon} className="h-5 w-5" />
                  </span>
                  {c.featured && (
                    <span className="absolute top-3 right-3 rounded-full bg-[var(--c-accent)] text-white text-xs font-body px-3 py-1">জনপ্রিয়</span>
                  )}
                </div>
                <div className="p-6 flex flex-col flex-1">
                  <h3 className="font-heading text-xl font-semibold text-[var(--c-primary)]">{c.title}</h3>
                  <div className="font-body text-sm text-[var(--c-secondary)] mt-1">{c.age}</div>
                  <p className="font-body text-sm text-[var(--c-muted)] mt-3 leading-relaxed flex-1">{c.desc}</p>
                  <div className="flex items-center justify-between mt-5 pt-4 border-t border-[var(--c-border)]">
                    <span className="font-heading text-[var(--c-primary)] font-semibold">{c.fees}</span>
                    <button onClick={go} className="inline-flex items-center gap-1 font-body text-sm text-[var(--c-secondary)] hover:gap-2 transition-all">
                      বিস্তারিত <ArrowRight className="h-4 w-4" />
                    </button>
                  </div>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
